import { formatCount, roomMeta, scoreLabel, villa } from '../data';
import { formatLongDate, formatPrice, isStayAvailable, nightsBetween, nightsLabel, occupancyLabel } from '../utils';

export default function PropertyPage({ property, search, onSearch, onHome, onBook }) {
  const nights = nightsBetween(search.checkIn, search.checkOut) || 1;
  const total = formatPrice(property.price * nights);
  const open = isStayAvailable(property, search.checkIn, search.checkOut);
  const meta = roomMeta(property);
  const hasDates = Boolean(search.checkIn && search.checkOut);

  return (
    <div className="page page-property">
      <div className="wrap">
        <div className="crumbs">
          <button onClick={onHome}>Home</button>
          <span>›</span>
          <button onClick={() => onSearch()}>{property.city}</button>
          <span>›</span>
          <span>{property.name}</span>
        </div>
        <div className="gallery">
          {property.images.map((src, i) => (
            <img key={src + i} src={src} alt={`${property.name} ${i + 1}`} />
          ))}
        </div>
        <div className="property-layout">
          <div className="property-copy">
            <p className="stay-bar-kicker">{property.city}, {property.country}</p>
            <h1>{property.name}</h1>
            <div className="property-meta">
              <span>{meta.beds}</span>
              <span>Sleeps {meta.sleeps}</span>
              <div className="rating-row">
                <span className="score">{property.score}</span>
                <div className="rating-copy">
                  <strong>{scoreLabel(property.score)}</strong>
                  <span>{formatCount(property.reviews)} reviews</span>
                </div>
              </div>
            </div>
            <p className="property-lead">{property.description}</p>

            <h2>Most popular facilities</h2>
            <div className="amenity-grid">
              {property.amenities.map((a) => <span className="amenity-chip" key={a}>{a}</span>)}
            </div>

            <section className="review-card">
              <h2>Guest reviews</h2>
              <blockquote>
                Guests who stayed here highlight the location, cleanliness and the fully equipped kitchen.
                Reviews on this demo are summarised from typical apartment feedback.
              </blockquote>
            </section>

            <section className="know-card">
              <h2>Good to know</h2>
              <ul>
                <li><span>Check-in</span><strong>From {villa.checkIn}</strong></li>
                <li><span>Check-out</span><strong>By {villa.checkOut}</strong></li>
                <li><span>Cancellation</span><strong>Free until 24 hours before arrival</strong></li>
              </ul>
            </section>
          </div>
          <aside className="reserve-box">
            <img src={property.images[0]} alt="" />
            <p className="stay-bar-kicker">Your stay</p>
            <h2>Reserve this stay</h2>
            <p>Perfect for {nightsLabel(nights)} in {property.city}.</p>
            <ul className="summary-facts">
              <li>
                <span>Dates</span>
                <strong>
                  {hasDates
                    ? `${formatLongDate(search.checkIn)} – ${formatLongDate(search.checkOut)}`
                    : 'Flexible dates — confirm when you reserve'}
                </strong>
              </li>
              <li>
                <span>Guests</span>
                <strong>{occupancyLabel(search.occupancy)}</strong>
              </li>
            </ul>
            <div className="reserve-price">
              <div className="price-now">{total}</div>
              <div className="price-note">{formatPrice(property.price)} / night · Includes taxes and charges</div>
            </div>
            <button type="button" className="see-btn book-submit" disabled={!open} onClick={() => open && onBook()}>
              {open ? 'Book now' : 'Unavailable for these dates'}
            </button>
          </aside>
        </div>
      </div>
    </div>
  );
}
